/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取订单获取成长值说明
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  orderGrowthReq: order.OrderGrowthReq,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: order.OrderGrowthRes;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/order/order-growth`,
    data: orderGrowthReq,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
